const STORAGE_KEY = "xpro4.teamMessageDrafts.v1";
const MAX_DRAFTS = 200;

function getWorkspaceSlug(teamCompany) {
  if (teamCompany) return String(teamCompany).trim().toLowerCase();
  try {
    return String(localStorage.getItem("company") || "").trim().toLowerCase() || "default";
  } catch {
    return "default";
  }
}

function buildDraftKey({ spaceId, userId, teamCompany }) {
  const uid = userId != null ? String(userId) : "anon";
  const ws = getWorkspaceSlug(teamCompany);
  return `${uid}:${ws}:${Number(spaceId)}`;
}

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* quota / private mode */
  }
}

function pruneStore(store) {
  const entries = Object.entries(store);
  if (entries.length <= MAX_DRAFTS) return store;
  entries.sort((a, b) => (b[1]?.updatedAt || 0) - (a[1]?.updatedAt || 0));
  return Object.fromEntries(entries.slice(0, MAX_DRAFTS));
}

export function loadTeamMessageDraft(spaceId, { userId, teamCompany } = {}) {
  if (!spaceId) return "";
  const key = buildDraftKey({ spaceId, userId, teamCompany });
  const entry = readStore()[key];
  return typeof entry?.text === "string" ? entry.text : "";
}

export function saveTeamMessageDraft(spaceId, text, { userId, teamCompany } = {}) {
  if (!spaceId) return;
  const key = buildDraftKey({ spaceId, userId, teamCompany });
  const value = typeof text === "string" ? text : "";
  const store = readStore();

  if (!value.trim()) {
    if (store[key]) {
      delete store[key];
      writeStore(pruneStore(store));
    }
    return;
  }

  store[key] = { text: value, updatedAt: Date.now() };
  writeStore(pruneStore(store));
}

export function clearTeamMessageDraft(spaceId, { userId, teamCompany } = {}) {
  saveTeamMessageDraft(spaceId, "", { userId, teamCompany });
}
